import _                           from 'underscore';
import classNames                  from 'classnames';
import React                       from 'react';
import { Icon, Popup, PopupProps } from 'semantic-ui-react';
import { FinePrintMessage }        from '@src/views/components/util/messaging/FinePrintMessage';
import { runIfFunction }           from '@src/util';


interface ActiveProjectVersionIndicatorProps {
    isActive: boolean,
    isLoading?: boolean,
    showPopup?: boolean,
    popupProps?: PopupProps,
    onClick?: () => void,
    activePopupMessage?: string,
    inactivePopupMessage?: string,
}

const ActiveProjectVersionIndicatorDefaultProps = {
    isActive:             false,
    isLoading:            false,
    showPopup:            true,
    popupProps:           {},
    onClick:              null,
    activePopupMessage:   'This is the active version your team is working on.',
    inactivePopupMessage: 'Your team is not actively focused on this version.'
} satisfies Partial<ActiveProjectVersionIndicatorProps>;

function ActiveProjectVersionIndicator( _props: ActiveProjectVersionIndicatorProps ){

    const props                                                   = { ...ActiveProjectVersionIndicatorDefaultProps, ..._props },
          { isActive, isLoading, onClick, showPopup, popupProps } = props,
          { activePopupMessage, inactivePopupMessage }            = props;

    const hasCallback = _.isFunction( onClick );

    return (
        <Popup
            disabled={ !showPopup }
            trigger={
                <Icon
                    size={ 'large' }
                    className={ classNames( {
                        'cursor--pointer':   hasCallback,
                        'opacity-hover--85': hasCallback
                    } ) }
                    onClick={ () => runIfFunction( onClick ) }
                    loading={ isLoading }
                    name={ isLoading ? 'circle notched' : ( isActive ? 'star' : 'star outline' ) }
                    color={ isLoading ? 'grey' : ( isActive ? 'yellow' : 'grey' ) }
                />
            }
            { ...popupProps }>

            <FinePrintMessage>{ isActive ? activePopupMessage : inactivePopupMessage }</FinePrintMessage>
        </Popup>
    );
}

export {
    ActiveProjectVersionIndicator,
    ActiveProjectVersionIndicatorDefaultProps,
    type ActiveProjectVersionIndicatorProps,
};
